import {
  REQUEST_CUSTOMER_SERVICE_ASSIGN_TO_USERS,
  RECEIVE_CUSTOMER_SERVICE_ASSIGN_TO_USERS,
  ERROR_CUSTOMER_SERVICE_ASSIGN_TO_USERS
} from "typeConstants";
import { customerService as initialState } from "../initialState.tsx";

const customerService = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CUSTOMER_SERVICE_ASSIGN_TO_USERS:
      return {
        ...state,
        isFetchingAssignToUsers: true,
      };
    case RECEIVE_CUSTOMER_SERVICE_ASSIGN_TO_USERS:
      return {
        ...state,
        assignToUsers: action.payload.map(x => {
          return { label: x.firstLastName, value: `${x.internetUserId}`, departmentCode: x.departmentCode, };
        }),
        isFetchingAssignToUsers: false,
      };
    case ERROR_CUSTOMER_SERVICE_ASSIGN_TO_USERS:
      return {
        ...state,
        isFetchingAssignToUsers: false,
      };
    default:
      return state;
  }
};

export default customerService;